import { CornerIconButton } from "@/src/components/buttons";
import { treatmentCategories, TreatmentCategory } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import { isNurse } from "@/src/utils/utils";

export function TreatmentResource({
  medicineId,
  title,
  remainingDays,
  onEditClick,
}: {
  medicineId: string;
  title: string;
  remainingDays: number;
  onEditClick?: () => void;
}) {
  let isCategory = treatmentCategories[medicineId as TreatmentCategory] != null;
  if (isCategory) return <span className="dark-gray">{title}</span>;
  let isLastDay = remainingDays == 0;
  return (
    <span className={`treatmentResource ${isLastDay ? "red-color" : ""} `}>
      <span className="bold capitalize" style={{ paddingRight: "15px" }}>
        {title}{" "}
      </span>
      {(remainingDays || 0) > 3 ? (
        <></>
      ) : (
        <div
          style={{
            maxWidth: "130px",
            marginTop: "4px",
            padding: "3px",
            marginLeft: "12px",
          }}
        >
          <span className="redish br  " style={{ padding: "5px" }}>
            {remainingDays} jour{remainingDays > 1 && <>s</>} restant
            {remainingDays > 1 && <>s</>}
          </span>
        </div>
      )}
      {!isNurse(USER.get()) && (
        <CornerIconButton
          type="edit"
          onClick={async () => {
            await onEditClick?.();
          }}
        ></CornerIconButton>
      )}
    </span>
  );
}
